<div class="publish-select-shell" [class.is-disabled]="questionBase.disabled">
  <app-search-admin-field #searchField
        [(myModel)]="inputValue"
        (onChange)="onChange($event)"
        (onSearch)="onSearch($event)"
        (onClick)="onClick()"
        [setOptions]="dataList"
        [dataStructure]="{name:'label', value:'value', title:'' }"
        [disabled]="questionBase.disabled"
        [ariaLabel]="questionBase.label"
        [professional]="true"
        [loading]="isLoading"
        [searchPlaceholder]="'חפש או בחר ' + questionBase.label"
        [multiSelect]="isMultiSelect"
        [initialSelectedItems]="selectedItemLabels"
  ></app-search-admin-field>
  <svg class="publish-select-search" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="11" cy="11" r="6.5"></circle>
    <path d="M16 16l4.25 4.25"></path>
  </svg>
  @if (isLoading) {
    <span class="publish-select-spinner" aria-hidden="true"></span>
  } @else if (inputValue) {
    <button
      type="button"
      class="publish-select-clear"
      aria-label="נקה בחירה"
      title="נקה בחירה"
      (mousedown)="$event.preventDefault()"
      (click)="searchField.clearSelection($event)">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 7l10 10M17 7L7 17"></path>
      </svg>
    </button>
  } @else {
    <span class="publish-select-chevron" aria-hidden="true"></span>
  }
</div>
